
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CarrinhoDrawerContainer from "../carrinho/CarrinhoDrawerContainer.vue";
const AppbarState = namespace("Appbar");

@Component({
  name: "CarrinhoDrawer",
  components: {
    CarrinhoDrawerContainer,
  },
})
export default class CarrinhoDrawer extends Vue {
  @AppbarState.Getter
  private getAppbarStatus!: any;

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
